/**
 * Valida los campos obligatorios para generar el finiquito.
 * Espeja exactamente el templateData de BulkSendFiniquitoModal y SiniestrosCompGrid.
 *
 * @param {object} siniestro - detalle del siniestro
 * @param {object|null} franquicia - detalle de la franquicia (puede ser null)
 * @returns {{ campo: string, etiqueta: string }[]}
 *   Array de campos faltantes. Vacío = todo OK.
 */
export function validarCamposFiniquito(siniestro, franquicia) {
  const errores = [];

  const falta = (valor) =>
    valor === null ||
    valor === undefined ||
    String(valor).trim() === "";

  // refAlbaran → "Nº referencia cliente" en cabecera
  if (falta(siniestro?.ref_albaran)) {
    errores.push({ campo: "ref_albaran", etiqueta: "Ref. Albarán" });
  }

  // aseguradoNombre → campo "Asegurado:" en cabecera
  if (falta(siniestro?.nombre_franquiciado)) {
    errores.push({ campo: "nombre_franquiciado", etiqueta: "Asegurado (nombre franquiciado)" });
  }

  // propiedadFranquicia → cuerpo del texto "X en méritos de..."
  // usa franquicia primero, si no nombre_franquiciado — si ambos vacíos, error
  const propiedadFranquicia =
    franquicia?.propiedad_franquicia ?? siniestro?.nombre_franquiciado ?? "";
  if (falta(propiedadFranquicia)) {
    errores.push({ campo: "propiedad_franquicia", etiqueta: "Propiedad franquicia / Nombre franquiciado" });
  }

  // fechaSiniestro → "ocurrido el día X" en el cuerpo
  if (falta(siniestro?.fecha_siniestro)) {
    errores.push({ campo: "fecha_siniestro", etiqueta: "Fecha del siniestro" });
  }

  // importeNetoCobrar → "la cantidad de X" — CRÍTICO
  const importe = siniestro?.importe_neto_cobrar;
  const importeNum = Number(String(importe ?? "").replace(",", "."));
  if (falta(importe) || !Number.isFinite(importeNum)) {
    errores.push({ campo: "importe_neto_cobrar", etiqueta: "Importe neto a cobrar" });
  }

  // cuenta → IBAN en la tabla del documento
  if (falta(siniestro?.cuenta)) {
    errores.push({ campo: "cuenta", etiqueta: "Cuenta (IBAN)" });
  }

  return errores;
}

/**
 * Formatea los errores como string legible para mostrar al usuario.
 * @param {{ campo: string, etiqueta: string }[]} errores
 * @returns {string}
 */
export function formatearErroresFiniquito(errores) {
  if (!errores.length) return "";
  return errores.map((e) => `• ${e.etiqueta}`).join("\n");
}